import React, { useCallback } from "react";
import * as styles from "./popover-panel.module.scss";

export type PopoverPanelHorizontalAlignment = "left" | "right" | "center";

export interface PopoverPanelProps {
	refPosition: HTMLElement | null;
	onClose?: () => void;
	horizontalAlign?: PopoverPanelHorizontalAlignment;

	children?: React.ReactNode;
}

/**
 * A popup panel that positions itself relative to a reference element.
 */
export default function PopoverPanel(props: PopoverPanelProps) {
	const propsOnClose = props.onClose;
	const onKey = useCallback(
		(event: React.KeyboardEvent) => {
			if (event.key === "Escape") {
				propsOnClose?.();
			}
		},
		[propsOnClose],
	);

	if (props.refPosition === null) {
		return null;
	}

	const positionRect = props.refPosition.getBoundingClientRect();

	let horizontalWrapperStyle: React.CSSProperties;
	switch (props.horizontalAlign) {
		case "left":
		default:
			horizontalWrapperStyle = {
				left: positionRect.left,
			};
			break;
		case "right":
			horizontalWrapperStyle = {
				right: window.innerWidth - positionRect.right,
			};
			break;
		case "center":
			horizontalWrapperStyle = {
				left: positionRect.left,
				transform: "translateX(-50%)",
			};
			break;
	}

	const verticalWrapperStyle: React.CSSProperties = {
		top: positionRect.bottom,
	};

	const wrapperStyle: React.CSSProperties = {
		...horizontalWrapperStyle,
		...verticalWrapperStyle,
	};

	return (
		<div role="presentation" className={styles.scrim} onKeyDown={onKey}>
			<div
				aria-hidden="true"
				className={styles.hitbox}
				onClick={props.onClose}
			/>
			<div style={wrapperStyle} className={styles.popover}>
				{props.children}
			</div>
		</div>
	);
}
